import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';


@Directive({
  selector: '[appTimeHhMmFormat]',
  standalone: true,
})
export class TimeHhMmFormatDirective {
  constructor(private readonly ngControl: NgControl) {}

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    if (event.key !== 'Backspace') return;

    const input = event.target as HTMLInputElement;
    const value = (this.ngControl.value ?? '') as string;
    if (value === '' || !value.endsWith(':')) return;

    const cursorAtEnd = input.selectionStart === value.length && input.selectionEnd === value.length;
    if (!cursorAtEnd) return;

    event.preventDefault();
    const newValue = value.slice(0, -1);
    this.ngControl.control?.setValue(newValue, { emitEvent: true });
    setTimeout(() => input.setSelectionRange(newValue.length, newValue.length), 0);
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = (this.ngControl.value ?? '') as string;

    if (value === '') return;

    // Only digits and at most one colon
    const cleaned = value.replaceAll(/[^\d:]/g, '');
    const parts = cleaned.split(':');
    if (parts.length > 2) return;

    let newValue: string | null = null;

    if (parts.length === 1) {
      const digits = parts[0];
      if (digits.length === 2) {
        newValue = digits + ':';
      } else if (digits.length === 4) {
        newValue = digits.slice(0, 2) + ':' + digits.slice(2);
      }
    }

    if (newValue != null && newValue !== value) {
      const valueToSet = newValue;
      this.ngControl.control?.setValue(valueToSet, { emitEvent: true });
      setTimeout(() => input.setSelectionRange(valueToSet.length, valueToSet.length), 0);
    }
  }
}
